/**
 * Master profession list for GetChosenFirst.
 * 100+ professions across 8 verticals.
 * Supports fuzzy search and "Other" free-text entry.
 */

export const PROFESSION_LIST = [
  // Home Services
  { label: "Plumber", value: "plumber", vertical: "home_services" },
  { label: "Electrician", value: "electrician", vertical: "home_services" },
  { label: "HVAC Technician", value: "hvac technician", vertical: "home_services" },
  { label: "Roofer", value: "roofer", vertical: "home_services" },
  { label: "Painter", value: "painter", vertical: "home_services" },
  { label: "Handyman", value: "handyman", vertical: "home_services" },
  { label: "Landscaper", value: "landscaper", vertical: "home_services" },
  { label: "General Contractor", value: "general contractor", vertical: "home_services" },
  { label: "Cleaning Service", value: "cleaning service", vertical: "home_services" },
  { label: "Carpenter", value: "carpenter", vertical: "home_services" },
  { label: "Fencing Contractor", value: "fencing contractor", vertical: "home_services" },
  { label: "Pool Service", value: "pool service", vertical: "home_services" },
  { label: "Pest Control", value: "pest control", vertical: "home_services" },
  { label: "Mover", value: "mover", vertical: "home_services" },
  { label: "Pressure Washer", value: "pressure washer", vertical: "home_services" },
  { label: "Window Cleaner", value: "window cleaner", vertical: "home_services" },
  { label: "Garage Door Repair", value: "garage door repair", vertical: "home_services" },
  { label: "Appliance Repair", value: "appliance repair", vertical: "home_services" },
  { label: "Locksmith", value: "locksmith", vertical: "home_services" },
  { label: "Septic Service", value: "septic service", vertical: "home_services" },
  { label: "Tree Service", value: "tree service", vertical: "home_services" },
  { label: "Paving/Concrete", value: "paving contractor", vertical: "home_services" },
  { label: "Flooring Installer", value: "flooring installer", vertical: "home_services" },
  { label: "Gutter Service", value: "gutter service", vertical: "home_services" },
  { label: "Home Inspector", value: "home inspector", vertical: "home_services" },
  { label: "Chimney Sweep", value: "chimney sweep", vertical: "home_services" },
  { label: "Insulation Contractor", value: "insulation contractor", vertical: "home_services" },
  { label: "Solar Installer", value: "solar installer", vertical: "home_services" },
  { label: "Restoration/Water Damage", value: "restoration service", vertical: "home_services" },

  // Health & Wellness
  { label: "Doctor (General)", value: "doctor", vertical: "health_wellness" },
  { label: "Dentist", value: "dentist", vertical: "health_wellness" },
  { label: "Chiropractor", value: "chiropractor", vertical: "health_wellness" },
  { label: "Physical Therapist", value: "physical therapist", vertical: "health_wellness" },
  { label: "Massage Therapist", value: "massage therapist", vertical: "health_wellness" },
  { label: "Acupuncturist", value: "acupuncturist", vertical: "health_wellness" },
  { label: "Mental Health Counselor", value: "mental health counselor", vertical: "health_wellness" },
  { label: "Therapist/Psychologist", value: "therapist", vertical: "health_wellness" },
  { label: "Psychiatrist", value: "psychiatrist", vertical: "health_wellness" },
  { label: "Optometrist", value: "optometrist", vertical: "health_wellness" },
  { label: "Dermatologist", value: "dermatologist", vertical: "health_wellness" },
  { label: "Pediatrician", value: "pediatrician", vertical: "health_wellness" },
  { label: "OB-GYN", value: "ob-gyn", vertical: "health_wellness" },
  { label: "Orthodontist", value: "orthodontist", vertical: "health_wellness" },
  { label: "Oral Surgeon", value: "oral surgeon", vertical: "health_wellness" },
  { label: "Naturopathic Doctor", value: "naturopathic doctor", vertical: "health_wellness" },
  { label: "Functional Medicine", value: "functional medicine practitioner", vertical: "health_wellness" },
  { label: "Med Spa", value: "med spa", vertical: "health_wellness" },
  { label: "Nutritionist/Dietitian", value: "nutritionist", vertical: "health_wellness" },
  { label: "Speech Therapist", value: "speech therapist", vertical: "health_wellness" },
  { label: "Occupational Therapist", value: "occupational therapist", vertical: "health_wellness" },

  // Beauty & Personal Care
  { label: "Hair Stylist", value: "hair stylist", vertical: "beauty" },
  { label: "Hair Colorist", value: "hair colorist", vertical: "beauty" },
  { label: "Barber", value: "barber", vertical: "beauty" },
  { label: "Nail Technician", value: "nail technician", vertical: "beauty" },
  { label: "Esthetician", value: "esthetician", vertical: "beauty" },
  { label: "Makeup Artist", value: "makeup artist", vertical: "beauty" },
  { label: "Lash Technician", value: "lash technician", vertical: "beauty" },
  { label: "Brow Specialist", value: "brow specialist", vertical: "beauty" },
  { label: "Tattoo Artist", value: "tattoo artist", vertical: "beauty" },
  { label: "Piercing Artist", value: "piercing artist", vertical: "beauty" },
  { label: "Spray Tan Technician", value: "spray tan technician", vertical: "beauty" },
  { label: "Waxing Specialist", value: "waxing specialist", vertical: "beauty" },
  { label: "Skincare Specialist", value: "skincare specialist", vertical: "beauty" },

  // Fitness
  { label: "Personal Trainer", value: "personal trainer", vertical: "fitness" },
  { label: "Fitness Coach", value: "fitness coach", vertical: "fitness" },
  { label: "Yoga Instructor", value: "yoga instructor", vertical: "fitness" },
  { label: "Pilates Instructor", value: "pilates instructor", vertical: "fitness" },
  { label: "CrossFit Coach", value: "crossfit coach", vertical: "fitness" },
  { label: "Group Fitness Instructor", value: "group fitness instructor", vertical: "fitness" },
  { label: "Martial Arts Instructor", value: "martial arts instructor", vertical: "fitness" },
  { label: "Swimming Coach", value: "swimming coach", vertical: "fitness" },
  { label: "Sports Coach", value: "sports coach", vertical: "fitness" },
  { label: "Dance Instructor", value: "dance instructor", vertical: "fitness" },
  { label: "Cycling Instructor", value: "cycling instructor", vertical: "fitness" },
  { label: "Strength Coach", value: "strength coach", vertical: "fitness" },
  { label: "Athletic Trainer", value: "athletic trainer", vertical: "fitness" },
  { label: "Golf Instructor", value: "golf instructor", vertical: "fitness" },
  { label: "Tennis Coach", value: "tennis coach", vertical: "fitness" },

  // Creative & Events
  { label: "Photographer", value: "photographer", vertical: "creative" },
  { label: "Videographer", value: "videographer", vertical: "creative" },
  { label: "DJ", value: "dj", vertical: "creative" },
  { label: "Wedding Planner", value: "wedding planner", vertical: "creative" },
  { label: "Event Planner", value: "event planner", vertical: "creative" },
  { label: "Florist", value: "florist", vertical: "creative" },
  { label: "Caterer", value: "caterer", vertical: "creative" },
  { label: "Baker/Cake Designer", value: "baker", vertical: "creative" },
  { label: "Graphic Designer", value: "graphic designer", vertical: "creative" },
  { label: "Interior Designer", value: "interior designer", vertical: "creative" },
  { label: "Web Designer", value: "web designer", vertical: "creative" },
  { label: "Musician/Band", value: "musician", vertical: "creative" },
  { label: "Face Painter", value: "face painter", vertical: "creative" },
  { label: "Balloon Artist", value: "balloon artist", vertical: "creative" },
  { label: "Photo Booth Operator", value: "photo booth operator", vertical: "creative" },

  // Professional Services
  { label: "Accountant/CPA", value: "accountant", vertical: "professional" },
  { label: "Bookkeeper", value: "bookkeeper", vertical: "professional" },
  { label: "Tax Preparer", value: "tax preparer", vertical: "professional" },
  { label: "Lawyer/Attorney", value: "lawyer", vertical: "professional" },
  { label: "Financial Advisor", value: "financial advisor", vertical: "professional" },
  { label: "Insurance Agent", value: "insurance agent", vertical: "professional" },
  { label: "Real Estate Agent", value: "real estate agent", vertical: "professional" },
  { label: "Mortgage Broker", value: "mortgage broker", vertical: "professional" },
  { label: "Notary", value: "notary", vertical: "professional" },
  { label: "Tutor", value: "tutor", vertical: "professional" },
  { label: "Music Teacher", value: "music teacher", vertical: "professional" },
  { label: "Driving Instructor", value: "driving instructor", vertical: "professional" },
  { label: "Translator/Interpreter", value: "translator", vertical: "professional" },
  { label: "Business Consultant", value: "business consultant", vertical: "professional" },
  { label: "IT Consultant", value: "it consultant", vertical: "professional" },
  { label: "Marketing Consultant", value: "marketing consultant", vertical: "professional" },

  // Pet Services
  { label: "Dog Groomer", value: "dog groomer", vertical: "pet_services" },
  { label: "Dog Walker", value: "dog walker", vertical: "pet_services" },
  { label: "Pet Sitter", value: "pet sitter", vertical: "pet_services" },
  { label: "Dog Trainer", value: "dog trainer", vertical: "pet_services" },
  { label: "Veterinarian", value: "veterinarian", vertical: "pet_services" },
  { label: "Mobile Vet", value: "mobile vet", vertical: "pet_services" },
  { label: "Pet Photographer", value: "pet photographer", vertical: "pet_services" },
  { label: "Pet Boarding", value: "pet boarding", vertical: "pet_services" },
  { label: "Aquarium Service", value: "aquarium service", vertical: "pet_services" },

  // Auto Services
  { label: "Auto Mechanic", value: "auto mechanic", vertical: "auto_services" },
  { label: "Auto Detailer", value: "auto detailer", vertical: "auto_services" },
  { label: "Body Shop", value: "body shop", vertical: "auto_services" },
  { label: "Towing Service", value: "towing service", vertical: "auto_services" },
  { label: "Mobile Mechanic", value: "mobile mechanic", vertical: "auto_services" },
  { label: "Tire Shop", value: "tire shop", vertical: "auto_services" },
  { label: "Auto Glass Repair", value: "auto glass repair", vertical: "auto_services" },
  { label: "Oil Change Service", value: "oil change service", vertical: "auto_services" },
];

/**
 * Fuzzy match professions against query text.
 * Returns matches sorted by relevance.
 */
export function searchProfessions(query) {
  if (!query || query.length < 2) return [];

  const q = query.toLowerCase().trim();
  const scored = [];

  for (const prof of PROFESSION_LIST) {
    const label = prof.label.toLowerCase();
    const value = prof.value.toLowerCase();

    // Exact starts-with match (highest priority)
    if (label.startsWith(q) || value.startsWith(q)) {
      scored.push({ ...prof, score: 100 });
      continue;
    }

    // Word starts-with match
    const words = label.split(/[\s\/\-()]+/);
    const wordMatch = words.some(w => w.startsWith(q));
    if (wordMatch) {
      scored.push({ ...prof, score: 80 });
      continue;
    }

    // Contains match
    if (label.includes(q) || value.includes(q)) {
      scored.push({ ...prof, score: 60 });
      continue;
    }

    // Fuzzy: check if query chars appear in order
    let qi = 0;
    for (let i = 0; i < label.length && qi < q.length; i++) {
      if (label[i] === q[qi]) qi++;
    }
    if (qi === q.length && q.length >= 3) {
      scored.push({ ...prof, score: 30 });
    }
  }

  scored.sort((a, b) => b.score - a.score);
  return scored.slice(0, 8);
}

/**
 * Check if a profession value exists in the master list.
 */
export function isKnownProfession(value) {
  return PROFESSION_LIST.some(p => p.value === value.toLowerCase());
}
